import { makeAutoObservable } from 'mobx';
import { WorkspaceModel, createObservableWorkspace } from '../models/workspace';
import { RawWorkspace, WorkspaceInputDetails } from '../interfaces/workspace';
import { WorkspaceInterface } from '../../interfaces/WorkspaceInterface';

export class WorkspaceStore {
  workspaces: WorkspaceModel[] = [];
  currentWorkspace: WorkspaceModel | null = null;
  loading: boolean = true;
  workspaceTotalTask: number = 0;
  workspaceInputDetails: WorkspaceInputDetails = {
    name: '',
    industry: { label: '', value: '' },
    teamType: { label: '', value: 0 },
    users: [{ email: '', name: '' }]
  };
  workspaceList: WorkspaceInterface[] | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setWorkspaceList(workspaceList: WorkspaceInterface[]) {
    this.workspaceList = workspaceList;
  }

  setCurrentWorkspace(rawWorkspace: RawWorkspace | null) {
    if (!rawWorkspace) {
      this.currentWorkspace = null;
      this.loading = false;
      return;
    }

    const observableWorkspace = createObservableWorkspace(rawWorkspace);

    const existingWorkspaceIndex = this.workspaces.findIndex((workspace) => workspace.id === rawWorkspace.id);

    if (existingWorkspaceIndex !== -1) {
      observableWorkspace.tabsStore = this.workspaces[existingWorkspaceIndex].tabsStore;
      this.workspaces[existingWorkspaceIndex] = observableWorkspace;
    } else {
      this.workspaces.push(observableWorkspace);
    }

    this.currentWorkspace = observableWorkspace;
    this.loading = false;
  }

  //set total workspace task
  setWorkspaceTotalTask(totalTask: number) {
    this.workspaceTotalTask = totalTask;
  }

  // Updates a specific property in `workspaceInputDetails`.
  updateWorkspaceInputDetail<K extends keyof WorkspaceInputDetails>(propsName: K, value: WorkspaceInputDetails[K]) {
    this.workspaceInputDetails[propsName] = value;
  }

  //Adds a new user object to the users list in `workspaceInputDetails`.
  addUserItem(item: { email: string; name: string }) {
    if (!this.workspaceInputDetails.users) {
      this.workspaceInputDetails.users = [];
    }
    this.workspaceInputDetails.users.push(item);
  }

  //Updates an existing user in the `users` list by index.
  updateUserItem(item: { email: string; name: string }, index: number) {
    if (this.workspaceInputDetails.users && index >= 0) {
      this.workspaceInputDetails.users[index] = item;
    }
  }

  //Removes a user from the `users` list by index.
  deleteUserItem(index: number) {
    if (this.workspaceInputDetails.users && index !== -1) {
      this.workspaceInputDetails.users.splice(index, 1);
    }
  }

  // Clears the `workspaceInputDetails` object.
  clearWorkspaceInputDetail() {
    this.workspaceInputDetails = {
      name: '',
      industry: { label: '', value: '' },
      teamType: { label: '', value: 0 },
      users: [{ email: '', name: '' }]
    };
  }
}
